<template>
    <div style="height: 100%; width: 100%;">
        <div class="custom-container" >
            <v-card flat>
                <v-card-title class="headline">
                    Mitarbeitergespräche
                </v-card-title>

                <!--<v-card-text>
                </v-card-text>-->
            </v-card>

            <v-card class="mt-4" v-if="$can('show interview employee')">
                <v-card-title>
                    Mitarbeitergespräche, die Sie durchgeführt haben
                    <v-spacer/>
                    <v-btn color="secondary" :to="{ name: 'EmployeeInterviewsCreate'}"><v-icon>mdi-plus</v-icon>Neues Gespräch </v-btn>
                </v-card-title>
                <v-card-title>
                    <v-text-field
                            v-model="searchSelf"
                            append-icon="mdi-magnify"
                            label="Suchen"
                            single-line
                            hide-details
                    ></v-text-field>

                </v-card-title>
                <EmployeeInterviewsUtilityInterviewsDataTable :headers="headers" :search="searchSelf" :items="interviewsSelf" type="employee">
                    <!--Customizing default rows-->
                </EmployeeInterviewsUtilityInterviewsDataTable>
            </v-card>

            <v-card class="mt-8" v-if="$can('show interview')">
                <v-card-title>
                    Mitarbeitergespräche (alle)
                    <v-spacer/>
                    <v-btn color="secondary" :to="{ name: 'EmployeeInterviewsCreate'}"><v-icon>mdi-plus</v-icon>Neues Gespräch</v-btn>
                </v-card-title>
                <v-card-title>
                    <v-text-field
                            v-model="searchAll"
                            append-icon="mdi-magnify"
                            label="Suchen"
                            single-line
                            hide-details
                    ></v-text-field>

                </v-card-title>
                <EmployeeInterviewsUtilityInterviewsDataTable :headers="headers" :search="searchAll" :items="interviewsAll" type="hr-department">

                </EmployeeInterviewsUtilityInterviewsDataTable>
            </v-card>
        </div>
    </div>
</template>

<script>
    export default {
        data: () => ({
            searchSelf: '',
            searchAll: '',
            headers: [
                {
                    text: '#',
                    align: 'start',
                    value: 'identifier'
                },
                { text: 'Datum', value: 'date_interview'},
                { text: 'P.-Nr.', value: 'staff_number'},
                { text: 'Vorname', value: 'first_name'},
                { text: 'Nachname', value: 'last_name'},
                { text: 'Organisationseinheit', value: 'orga_unit'},
                { text: 'Risikobewertung', value: 'risk_score'},
                { text: 'Freigabe', value: 'is_released'},
                { value: 'action'},
            ],

            interviewsSelf: [],
            interviewsAll: [],
        }),
        created() {

        },
        mounted() {
          this.getAll();
          this.getOwn();
        },
        methods: {
            getAll(){
                this.axios.get('/interviews').then( (response) => {
                    this.interviewsAll = Object.values({...response.data.data.interviews});
                });
            },
            getOwn(){
                this.axios.get('/interviews?type=created').then( (response) => {
                    this.interviewsSelf = Object.values({...response.data.data.interviews});
                });
            }

        }

    }
</script>

<style scoped>

</style>